<template>
  <section class="page">
    <!-- Vue tag to add header component -->
      <!-- Button to edit document in dashboard -->
      <prismic-edit-button :documentId="documentId"/>
      <!-- Slices block component -->
      <slices-block :slices="slices"/>
      <footer-prismic/>
  </section>
</template>

<script>
// imports for all components
import FooterPrismic from '../components/FooterPrismic.vue'
import SlicesBlock from '../components/SlicesBlock.vue'

export default {
  name: 'page',
  components: {
    SlicesBlock,
    FooterPrismic
  },
  data () {
    return {
      documentId: '',
      slices: [],
      meta: {
        seo_title: null,
        seo_description: null
      },
      show: false,
    }
  },
  metaInfo() {
    return {
      title: this.meta.seo_title,
      meta: [
        {vmid: 'description', name: 'description', content: this.meta.seo_description}
      ]
    }
  },
  methods: {
    getContent (uid) {
      //Query to get post content
      this.$prismic.client.getByUID('page', uid)
        .then((document) => {
          if (document) {
            this.documentId = document.id;
            this.meta.seo_title = document.data.seo_title;
            this.meta.seo_description = document.data.seo_description;

            //Set slices as variable
            this.slices = document.data.page_content
          }
          else {
            //returns error page
            this.$router.push({ name: 'not-found' })
          }
        })
    }
  },
  created () {
    this.getContent(this.$route.params.uid)
  },
  beforeRouteUpdate (to, from, next) {
    this.getContent(to.params.uid)
    next()
  }
}
</script>
<style lang="scss">
  section.page section.full-width-image.content-section {
    max-width: 50%;
    margin: auto;
    margin-top: 100px;
  }
</style>


